import { forwardRef, isValidElement } from "react"
import { Text } from ".."
import classnames from "classnames"
import type { CardFooterProps } from "./types"

export const CardFooter = forwardRef<HTMLDivElement, CardFooterProps>(
  ({ children, startAdornment, endAdornment, className: classNameProp, ...rest }, ref) => {
    const _children = typeof children === "string" ? <Text>{children}</Text> : children

    return (
      <div ref={ref} className={classnames(classNameProp, "flex items-center gap-x-2")} {...rest}>
        {isValidElement(startAdornment) && startAdornment}
        <div className="grow">{_children}</div>
        {isValidElement(endAdornment) && endAdornment}
      </div>
    )
  },
)

CardFooter.displayName = "Card.Footer"
